import { SendApplicationPortalConfig } from '../types';

export const sendApplicationDefaultConfig: SendApplicationPortalConfig = {
  excludedLenderProfileIds: [],
};
